import { Navigate, useSearchParams } from 'react-router-dom';
import { isAuthenticated } from '@alchemiesolns/product-registration';
import { resolveRootRedirect } from '../auth/resolveRootRedirect';
import { useAuthUser } from '@alchemiesolns/user-access';

export function RootRedirect() {
  const [searchParams] = useSearchParams();
  const { user, ready } = useAuthUser();
  const bypassBilling = import.meta.env.VITE_BYPASS_BILLING === 'true';

  const result = resolveRootRedirect({
    bypassBilling,
    authReady: ready,
    licenseAuthenticated: isAuthenticated(),
    user: user ?? null,
    searchParams,
  });

  if (result.kind === 'loading') {
    return (
      <div className="min-h-screen bg-slate-100 flex items-center justify-center text-slate-600 text-sm">
        Loading…
      </div>
    );
  }

  return <Navigate to={result.to} replace />;
}
